// Cart page quantity +/- handler
// CartItems constructor fails on cart page due to load order (debounce undefined at upgrade time),
// so we handle quantity changes here explicitly.
(function() {
  var updateTimer;
  $(document).on('click', '.cart-quantity .quantity__button', function() {
    var $button = $(this);
    var $input = $button.closest('quantity-input').find('.quantity__input');
    var currentId = $button.closest('.cart-item').attr('data-id');
    if (!currentId || !$input.length) return;

    var $removeButton = $button.closest('.cart-item').find('cart-remove-button');
    clearTimeout(updateTimer);
    updateTimer = setTimeout(function() {
      var qty = parseInt($input.val(), 10);
      if (isNaN(qty) || qty < 0) return;

      $removeButton.addClass('loading');

      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: JSON.stringify({ updates: { [currentId]: qty } }),
        dataType: 'json',
        contentType: 'application/json',
        success: function(cart) {
          var cartCountEl = document.querySelector('#header-icons .cart-button__count');
          if (cartCountEl) {
            cartCountEl.querySelector('.cart-button__count-number').textContent = cart.item_count;
            cartCountEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
          }
          updateCartPage();
        }
      });
    }, 500);
  });
})();

$(document).ready(function(){
    $(document).on('click','.cart_upsell_popup_opener-js',function(){
        var currentId = $(this).attr('data-id');
        $('.pp_addon_poppup_accordion_container').hide();
        $('.pp_addon_poppup_accordion_container[data-id="'+currentId+'"]').show();

        $('.variantImage__js-addone').addClass('active');

        $('.add--one--modal__content').attr('data-product-id', currentId);
    });

    $(document).on('click','.complete_cart__button',function(){
        $(this).find('.desk_btn_content').hide();
        $(this).find('.desk_button_loader').show();
        $(this).find('.desk_btn_loader').show();
        $(this).addClass('loading');
    });

    $(document).on('click','cart-remove-button',function(){
        $(this).addClass('loading');
    });
    
    $(document).on('click','.cart__checkout-button',function(){
        $('.cart__checkout-button').find('.desk_btn_content').hide();
        $('.cart__checkout-button').find('.desk_btn_loader').show();

        setTimeout(function(){
            $('.cart__checkout-button').find('.desk_btn_content').show();
            $('.cart__checkout-button').find('.desk_btn_loader').hide();
        },1000);

        window.location.href = '/checkout';
        
    });

});